<template>
  <div
    v-if="products && products.length > 0"
    :class="productCarouselClass"
    role="region"
  >
    <flickity
      v-if="flickityActive"
      ref="flickity"
      class="flickity"
      :options="flickityOptions"
    >
      <div
        v-for="(product, index) in screenedProducts"
        :key="`f-${product.id}--${index}`"
        class="carousel-cell"
      >
        <product-carousel-card v-bind="product" />
      </div>
    </flickity>
    <div
      v-else
      class="l-flex"
    >
      <template v-for="(product, index) in screenedProducts">
        <div
          :key="`e-${product.id}--${index}`"
          class="c-product-carousel__item"
        >
          <product-carousel-card
            v-bind="product"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import flickityActive  from './flickityActive'
import get from 'lodash/get'

export default {
  mixins: [
    flickityActive
  ],
  props: {
    products: {
      type: Array,
      default: () => []
    },
    forceMobile: {
      type: Boolean,
      default: false,
    },
    centerCarousel: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: true,
        cellAlign: '',
        imagesLoaded: true,
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      }
    }
  },
  computed: {
    productCarouselClass() {
      let results = ['c-product-carousel'];
      if (this.classes) {
        results.push(this.classes);
      }
      if (this.forceMobile) {
        results.push('c-product-carousel--mobile');
      }
      if (this.centerCarousel) {
        results.push('c-product-carousel--center-carousel');
      }
      return results;
    },
    screenedProducts() {
      const products = this.products
      let results = []
      for (let product of products) {
        let tempProduct = {
          title: get(product, 'metafieldsMap.collection_label.value', '')
            .replace('Silicone Ring', '')
            .replace('Classic', '')
            .replace('Contour', '')
        }
        tempProduct.price = get(product, 'variants[0].price')
        if (get(product, 'variants[0].compareAtPrice')) {
          tempProduct.originalPrice = get(product, 'variants[0].compareAtPrice')
        }
        if (product.metafieldsMap) {
          //JSON.parse(metafield.value).name
          tempProduct.subtitle = get(product, 'metafieldsMap.color.value.name')
          tempProduct.width = get(product, 'metafieldsMap.width.value')
        } else {
          console.warn('[product-carousel] missing metafieldsMap!')
        }

        tempProduct.url = '/products/' + product.handle
        tempProduct.image = get(product, 'featuredImage.src')
        tempProduct.imageAlt = get(product, 'featuredImage.alt')
        if (get(product, 'media[1]')) {
          tempProduct.hoverImage = get(product, 'hoverImage.src')
          tempProduct.hoverImageAlt = get(product, 'hoverImage.alt')
        } else {
          tempProduct.hoverImage = get(product, 'featuredImage.src')
          tempProduct.hoverImageAlt = get(product, 'featuredImage.alt')
        }
        tempProduct.tags = product.tags
        results.push(tempProduct)
      }
      return results
    }
  },
  watch: {
    async products() {
      await this.$nextTick()
      this.flickityActivator();
    }
  },
  methods: {
    async flickityActivator() {
      this.flickityActive = false;
      if (this.centerCarousel) {
        this.flickityOptions.cellAlign = 'center'
      } else {
        this.flickityOptions.cellAlign = 'left'
      }
      // $nextTick https://vuejs.org/v2/api/#vm-nextTick
      await this.$nextTick()
      if (this.products.length > 2 && this.forceMobile) {
        this.flickityActive = true;
        return
      }
      if (this.products.length > 5) {
        this.flickityActive = true;
        return
      }
      if (window.innerWidth < 1100) {
        if (this.products.length > 4) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 800) {
        if (this.products.length > 3) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 600) {
        if (this.products.length > 2) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 400) {
        if (this.products.length > 1) {
          this.flickityActive = true;
          return
        }
      }
      return
    },
  },
}
</script>

<style lang="scss">
  /* external css: flickity.css */
  .c-product-carousel {
    &__item {
      &:not(:last-child) {
        margin-right: rem(60px);
      }
    }
  }

  //flickity class override for forced mobile
  .flickity {
    &:focus-visible {
      outline: none !important;
    }
  }
  .c-product-carousel--mobile {
    .flickity-enabled.is-draggable {
      padding-left: 30px;
      padding-right: 30px;
      max-width: 550px;
      margin: auto;
    }
    .carousel-cell {
      height: auto;
      min-height: rem(290px);
      margin-right: rem(10px);
      border-radius: 5px;
      width: 50%;
      border-radius: 5px;
      counter-increment: gallery-cell;
    }



    // prev and next buttons
    .flickity-prev-next-button {
      top: 50%;
    }
    button.flickity-prev-next-button {
      width: 55px;
      height: 55px;
    }
    .flickity-prev-next-button.previous svg.flickity-button-icon {
      left: 0;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
    .flickity-prev-next-button.next svg.flickity-button-icon {
      right: 0;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
  }

  //flickity class override
  .c-product-carousel {
    .flickity-enabled.is-draggable {
      padding-left: 50px;
      padding-right: 50px;
      margin: auto;
      //max-width: rem(1100px);
      ::v-deep {
        .flickity-prev-next-button.previous {
          left: 0;
        }
        .flickity-prev-next-button.next {
          right: 0;
        }
      }
    }
    .carousel-cell {
      height: auto;
      min-height: rem(290px);
      margin-right: rem(5px);
      margin-left: rem(5px);
      border-radius: 5px;
      width: 265px;

      @include respond(phone) {
        width: 170px;
      }

      @include respond(tab-land) {
        width: 200px;
      }
      border-radius: 5px;
      counter-increment: gallery-cell;
    }

    button.flickity-button.flickity-prev-next-button.previous {
      background: transparent;
    }
    .flickity-prev-next-button.previous svg.flickity-button-icon {
      left: 29px;
    }
    .flickity-prev-next-button.next svg.flickity-button-icon {
      right: 0;
    }
    // prev and next buttons
    .flickity-prev-next-button {
      top: 50%;
    }
    .flickity-prev-next-button svg.flickity-button-icon {
      //left: 100%;
    }
    .flickity-button {
      background: transparent;
      &:hover {
        background: transparent;
      }
    }
    button.flickity-prev-next-button {
      width: 55px;
      height: 55px;
    }
  }
</style>
